module.exports = __webpack_public_path__ + "img/hr-H-B-135-unload-connect.d6250574.png";